<app-card icon="refresh" title="Cancel & Change Statistics" iconGradient="from-red-500 to-pink-600" class="h-full">
    <ng-template #headerTemplate>
        <div class="ml-auto">
            <app-excel-button
                [data]="exportData()"
                [excelTitle]="'agent-reservation-cancel-and-change'"
                [columns]="cols"
            ></app-excel-button>
        </div>
    </ng-template>
    <app-table-component
        [cols]="cols"
        [data]="agentBiStatisticData() || []"
        [loading]="loading()"
        [oddRowColor]="'#e9f1f8'"
    ></app-table-component>
</app-card>
